export interface HelpItem {
  title?: string
  content: string[]
}

export const KEYBOARD_HELP: HelpItem[] = [
  {
    content: [
      '<kbd>?</kbd> Keyboard shortcuts help',
      '<kbd>g</kbd> Open the command bar',
      '<kbd>Esc</kbd> Close any modal dialog',
    ],
  },
  {
    title: 'Element details',
    content: [
      '<kbd>Ctrl</kbd> + <kbd><i class="icon-arrow-left"></i></kbd> Previous element in first parent',
      '<kbd>Ctrl</kbd> + <kbd><i class="icon-arrow-right"></i></kbd> Next element in first parent',
    ],
  },
  {
    title: 'Annotation',
    content: [
      '<kbd>Esc</kbd> Cancel drawing a polygon',
      '<kbd>Enter</kbd> In an annotation form, create or update an element',
    ],
  },
  {
    title: 'Children tree',
    content: ['<kbd>m</kbd> Load more children elements'],
  },
  {
    title: 'Dataset details',
    content: ['<kbd>m</kbd> Load more elements on the current set'],
  },
]
